import ory from '../config/ory';
import {
  FrontendApiCreateBrowserLoginFlowRequest,
  FrontendApiCreateBrowserRegistrationFlowRequest,
} from '@ory/client';
import {
  FrontendApiUpdateLoginFlowRequest,
  FrontendApiUpdateRecoveryFlowRequest,
  FrontendApiUpdateRegistrationFlowRequest,
  FrontendApiUpdateVerificationFlowRequest,
  UpdateSettingsFlowBody,
} from '@ory/client/api';
import Axios from 'utils/axios';

export const createRegistrationFlow = (
  requestParameters: FrontendApiCreateBrowserRegistrationFlowRequest = {},
  defaultRequestOptions = {},
) => ory.createBrowserRegistrationFlow(
  requestParameters,
  defaultRequestOptions,
);

export const getRegistrationFlow = (flowId: string) => 
  ory.getRegistrationFlow({ id: flowId });

export const updateRegistrationFlow = (
  flowBody: FrontendApiUpdateRegistrationFlowRequest,
  defaultRequestOptions = {},
) => 
  ory.updateRegistrationFlow(flowBody, defaultRequestOptions);

export const createLoginFlow = (
  requestParameters: FrontendApiCreateBrowserLoginFlowRequest = {},
  defaultRequestOptions = {},
) => 
  ory.createBrowserLoginFlow(requestParameters, defaultRequestOptions);

export const getLoginFlow = (flowId: string) => 
  ory.getLoginFlow({ id: flowId });

export const updateLoginFlow = (
  flowBody: FrontendApiUpdateLoginFlowRequest,
  defaultRequestOptions = {},
) => 
  ory.updateLoginFlow(flowBody, defaultRequestOptions);

export const getVerificationFlow = (flowId: string) => 
  ory.getVerificationFlow({ id: flowId });

export const createVerificationFlow = (defaultRequestOptions = {}) => 
  ory.createBrowserVerificationFlow(defaultRequestOptions);

export const updateVerificationFlow = (
  flowBody: FrontendApiUpdateVerificationFlowRequest,
  defaultRequestOptions = {},
) => 
  ory.updateVerificationFlow(flowBody, defaultRequestOptions);

export const createLogoutFlow = () => 
  ory.createBrowserLogoutFlow();

export const updateLogoutFlow = (
  logoutToken: string,
  defaultRequestOptions = {},
) => 
  ory.updateLogoutFlow({ token: logoutToken }, defaultRequestOptions);

export const getSession = () => 
  ory.toSession();

export const createRecoveryFlow = () => 
  ory.createBrowserRecoveryFlow();

export const getRecoveryFlow = (flowId: string) => 
  ory.getRecoveryFlow({ id: flowId });

export const updateRecoveryFlow = (
  flowBody: FrontendApiUpdateRecoveryFlowRequest,
  defaultRequestOptions = {},
) => 
  ory.updateRecoveryFlow(flowBody, defaultRequestOptions);

export const createBrowserSettingsFlow = (defaultRequestOptions = {}) => 
  ory.createBrowserSettingsFlow(defaultRequestOptions);

export const getSettingsFlow = (flowId: string) => 
  ory.getSettingsFlow({ id: flowId });

export const updateSettingsFlow = (
  flowId: string,
  flowBody: string,
  defaultRequestOptions = {},
) => 
  ory.updateSettingsFlow(
    {
      flow: flowId,
      updateSettingsFlowBody: flowBody as unknown as UpdateSettingsFlowBody,
    },
    defaultRequestOptions,
  );

export const getConsentSession = () => 
  Axios.get('/self-service/settings/consent', {
    withCredentials: true,
    baseURL: window.REACT_APP_KRATOS_BROWSER_URL,
  });

export const updateAvatar = (data: FormData) => 
  Axios.post('/self-service/avatar', data, {
    withCredentials: true,
    baseURL: window.REACT_APP_KRATOS_BROWSER_URL,
  });

export const deleteAvatar = () => 
  Axios.delete('/self-service/avatar', {
    withCredentials: true,
    baseURL: window.REACT_APP_KRATOS_BROWSER_URL,
  });
  
export const checkAvatar = () => 
  Axios.get('/self-service/avatar', {
    withCredentials: true,
    baseURL: window.REACT_APP_KRATOS_BROWSER_URL,
  });

export const getAvatar = (index: number) => 
  `${window.REACT_APP_KRATOS_BROWSER_URL}/self-service/avatar?index=${index}`;

export const deleteConsentSessionByClientId = (clientId: string) => 
  Axios.delete(`/self-service/settings/consent?clientId=${clientId}`, {
    withCredentials: true,
    baseURL: window.REACT_APP_KRATOS_BROWSER_URL,
  });

export const getSignInSessions = () => 
  Axios.get('/sessions/recent', {
    withCredentials: true,
    baseURL: window.REACT_APP_KRATOS_BROWSER_URL,
  });

export const disableSignInSession = (sessionId: string) =>
  Axios.delete(`/sessions/${sessionId}`, {
    withCredentials: true,
    baseURL: window.REACT_APP_KRATOS_BROWSER_URL,
  });

export const getError = (id: string) =>
  Axios.get('self-service/errors', {
    params: { id },
    withCredentials: true,
    baseURL: window.REACT_APP_KRATOS_BROWSER_URL,
  });
